import modelId from '../src/procedures/model-id';

export default {
  index(url) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements' + url);
  },
  indexEmploymentContractAgreements() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/employment_contracts?list');
  },
  show(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/' + id);
  },
  store(agreement) {
    agreement = JSON.parse(JSON.stringify(agreement));
    agreement.number = agreement.number.number;
    agreement.type = agreement.type.id;
    agreement.employee = agreement.employee.id;
    agreement.tax_deductible_amount_type = agreement.tax_deductible_amount_type.id;
    agreement.gross_salary = agreement.gross_salary ? agreement.gross_salary : null;
    agreement.retirement_insurance = Number(!!agreement.retirement_insurance);
    agreement.pension_insurance = Number(!!agreement.pension_insurance);
    agreement.sickness_insurance = Number(!!agreement.sickness_insurance);
    agreement.accident_insurance = Number(!!agreement.accident_insurance);
    agreement.fp = Number(!!agreement.fp);
    agreement.fgsp = Number(!!agreement.fgsp);
    agreement.health_insurance = Number(!!agreement.health_insurance);

    return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/agreements', {
      agreement: prepareAgreement(agreement),
    });
  },
  update(agreement) {
    agreement = JSON.parse(JSON.stringify(agreement));
    agreement.employee = agreement.employee.id;
    agreement.type = agreement.type.id;
    agreement.tax_deductible_amount_type = Number.isInteger(agreement.tax_deductible_amount_type) ? agreement.tax_deductible_amount_type : agreement.tax_deductible_amount_type.id;
    agreement.retirement_insurance = Number(!!agreement.retirement_insurance);
    agreement.pension_insurance = Number(!!agreement.pension_insurance);
    agreement.sickness_insurance = Number(!!agreement.sickness_insurance);
    agreement.accident_insurance = Number(!!agreement.accident_insurance);
    agreement.fp = Number(!!agreement.fp);
    agreement.fgsp = Number(!!agreement.fgsp);
    agreement.health_insurance = Number(!!agreement.health_insurance);
    agreement.number = agreement.number.number;

    delete agreement.boss;

    return axios.put(import.meta.env.VITE_SITE_URL + '/staffs/agreements/' + agreement.id, {
      agreement: prepareAgreement(agreement),
    });
  },
  destroy(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/staffs/agreements/' + id);
  },
  print(payload) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print', { data: payload });
  },
  preview(payload) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/print/preview', { data: payload });
  },
  setTerminationDate(agreement) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/staffs/agreements/set-termination-date/' + agreement.id, { agreement });
  },
  getTaxDeductibleAmount(payload) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/agreements/tax-deductible-amount', payload);
  },
  getVersions(original) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/versions/' + original);
  },
  storeAnnex({ annex, id }) {
    annex = JSON.parse(JSON.stringify(annex));
    annex.number = annex.number.number;
    annex.type = modelId(annex.type);
    annex.employee = annex.employee.id;
    annex.tax_deductible_amount_type = modelId(annex.tax_deductible_amount_type);
    annex.gross_salary = annex.gross_salary ? annex.gross_salary : null;
    annex.retirement_insurance = Number(!!annex.retirement_insurance);
    annex.pension_insurance = Number(!!annex.pension_insurance);
    annex.sickness_insurance = Number(!!annex.sickness_insurance);
    annex.accident_insurance = Number(!!annex.accident_insurance);
    annex.fp = Number(!!annex.fp);
    annex.fgsp = Number(!!annex.fgsp);
    annex.health_insurance = Number(!!annex.health_insurance);
    annex.annex_to_agreement_id = annex.annex_to_agreement_id === null ? id : annex.annex_to_agreement_id;

    return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/agreement-annexes', {
      agreement: prepareAgreement(annex),
    });
  },
  updateAgreementAnnex(annex) {
    annex = JSON.parse(JSON.stringify(annex));
    annex.employee = annex.employee.id;
    annex.type = modelId(annex.type);
    annex.tax_deductible_amount_type = Number.isInteger(annex.tax_deductible_amount_type) ? annex.tax_deductible_amount_type : annex.tax_deductible_amount_type.id;
    annex.retirement_insurance = Number(!!annex.retirement_insurance);
    annex.pension_insurance = Number(!!annex.pension_insurance);
    annex.sickness_insurance = Number(!!annex.sickness_insurance);
    annex.accident_insurance = Number(!!annex.accident_insurance);
    annex.fp = Number(!!annex.fp);
    annex.fgsp = Number(!!annex.fgsp);
    annex.health_insurance = Number(!!annex.health_insurance);
    annex.number = annex.number.number;
    annex.annex_original_id = annex.annex_original_id;

    delete annex.boss;

    return axios.put(import.meta.env.VITE_SITE_URL + '/staffs/agreement-annexes/' + annex.id, {
      agreement: prepareAgreement(annex),
    });
  },
  destroyAgreementAnnex(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/staffs/agreement-annexes/' + id);
  },
  DEDUCTIONS: {
    index(url) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/payments/deductions' + url);
    },
    indexByPeriod(payload) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/payments/deductions/byPeriod', payload);
    },
    indexAgreementDeductionsForPayment(payment) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/payments/deductions/payment/' + payment);
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/payments/deductions/' + id);
    },
    store(deduction) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/payments/deductions', { paymentdeduction: prepareDeduction(deduction) });
    },
    update(deduction) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/staffs/payments/deductions/' + deduction.id, { paymentdeduction: prepareDeduction(deduction) });
    },
  },
  NUMBER: {
    generate(payload) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/number', payload);
    },
  },
  TYPES: {
    index(payload) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/types');
    },
  },
  CODES: {
    indexInsuranceTitleCodeOptions() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/insurance-title-codes');
    },
    indexRetirementEntitlementCodes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/retirement-entitlement-codes');
    },
    indexDisabilityLevelCodes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/disability-level-codes');
    },
    indexHealthInsuranceCodes() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/agreements/health-insurance-codes');
    },
  },
};

function prepareAgreement(agreement) {
  agreement = { ...agreement };
  if (agreement.attachment) {
    agreement.duties_description = 'szczegółowy zakres obowiązków, uprawnień i odpowiedzialności Pracownika, będący integralną częścią umowy, określa załącznik zatytułowany „Zakres obowiązków”.';
  }

  return agreement;
}

function prepareDeduction(deduction) {
  deduction = { ...deduction };
  if (deduction.single) {
    let id = deduction.agreements.id;
    deduction.agreements = [];
    deduction.agreements[0] = { id };
  } else {
    deduction.agreements = deduction.agreements.map(el => {
      return {
        id: el.id,
      };
    });
  }
  return deduction;
}
